export default {
  permissions_CONTAINER: { display: "flex", flexWrap: "wrap", gap: 2, rowGap: 4, mt: 3 },
  ROLE_PERMISSIONS_CONTAINER: {
    flex: "1 1 300px",
    border: "1px solid rgba(0, 0, 0, 0.12)",
    borderRadius: "4px",
    pb: 2,
  },
  ROLE_FORM_CONTROL_LABEL: {
    mt: -3.5,
    ml: 1,
    paddingInlineEnd: "1rem",
    bgcolor: "#fff",
  },
  PERMISSIONS_LIST_CONTAINER: {
    display: "flex",
    flexDirection: "column",
    ml: 5,
    width: "fit-content",
  }
}